import { useOutletContext } from 'react-router-dom'

export function useDashboardEmbedded(): boolean {
  const ctx = useOutletContext<{ embedded?: boolean } | undefined>()
  return ctx?.embedded ?? false
}
